var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "menu-svg",
    d: "M5.80001 7.9C3.53001 7.31 2.80001 6.7 2.80001 5.75C2.80001 4.66 3.81001 3.9 5.50001 3.9C7.28001 3.9 7.94001 4.75 8.00001 6H10.21C10.14 4.28 9.09001 2.7 7.00001 2.19V0H4.00001V2.16C2.06001 2.58 0.500007 3.84 0.500007 5.77C0.500007 8.08 2.41001 9.23 5.20001 9.9C7.70001 10.5 8.20001 11.38 8.20001 12.31C8.20001 13 7.71001 14.1 5.50001 14.1C3.44001 14.1 2.63001 13.18 2.52001 12H0.320007C0.440007 14.19 2.08001 15.42 4.00001 15.83V18H7.00001V15.85C8.95001 15.48 10.5 14.35 10.5 12.3C10.5 9.46 8.07001 8.49 5.80001 7.9Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/Invoices.0b9258c0.svg";
export { ForwardRef as ReactComponent };